/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/**
 * 交换机状态
 */
export const SwitchPortStatusE = {
    LINK_DOWN: {
        value: 0,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_LINK_DOWN',
    },
    LINK_UP: {
        value: 1,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_LINK_UP',
    },
};
